module.exports = __webpack_public_path__ + "img/love.54b62ad7.jpg";